module.exports = __webpack_public_path__ + "static/scale-model-of-great-overland-station-in-topeka-kansas-925d84ff8b128f0c95864f67bce0b3ad.png";